function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#aknkr0mw3a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tgtj1pv74b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M110.521 94.042c12.666 3.388 26.357-2.565 32.28-14.803 6.71-13.863.911-30.54-12.952-37.25L79.647 17.69c-13.863-6.71-30.54-.911-37.25 12.952-5.923 12.238-2.099 26.669 8.416 34.5-12.665-3.388-26.356 2.565-32.28 14.803-6.71 13.863-.91 30.54 12.952 37.25l50.202 24.299c13.863 6.709 30.541.911 37.25-12.952 5.924-12.238 2.099-26.669-8.416-34.5z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m110.521 94.042-.896 1.203 1.284-2.653-.388 1.45zm-59.708-28.9.896-1.203-1.283 2.652.387-1.45zm93.338 14.75c-6.243 12.898-20.67 19.17-34.017 15.599l.775-2.898c11.983 3.206 24.938-2.43 30.542-14.008l2.7 1.307zm-13.648-39.254c14.608 7.071 20.719 24.646 13.648 39.254l-2.7-1.307c6.349-13.117.862-28.897-12.255-35.246l1.307-2.7zM80.301 16.34l50.202 24.298-1.307 2.7L78.994 19.04l1.307-2.7zM41.047 29.988C48.117 15.38 65.692 9.27 80.301 16.34l-1.307 2.7c-13.117-6.349-28.898-.862-35.247 12.255l-2.7-1.307zm8.87 36.357c-11.08-8.253-15.113-23.46-8.87-36.357l2.7 1.307C38.143 42.873 41.761 56.53 51.71 63.94l-1.792 2.406zM17.183 79.29c6.243-12.897 20.67-19.169 34.018-15.598l-.775 2.898c-11.984-3.206-24.938 2.43-30.542 14.007l-2.7-1.307zm13.649 39.254c-14.609-7.071-20.72-24.645-13.649-39.254l2.7 1.307c-6.348 13.118-.861 28.898 12.256 35.247l-1.307 2.7zm50.202 24.299-50.202-24.299 1.307-2.7 50.202 24.298-1.307 2.701zm39.254-13.649c-7.071 14.609-24.646 20.719-39.254 13.649l1.307-2.701c13.117 6.349 28.897.863 35.246-12.255l2.701 1.307zm-8.871-36.356c11.081 8.252 15.113 23.459 8.871 36.356l-2.701-1.307c5.604-11.578 1.987-25.234-7.962-32.643l1.792-2.407z",
  fill: "#4E5EFA",
  mask: "url(#tgtj1pv74b)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "aknkr0mw3a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "rotate(-64.172 86.14 54.007)",
  d: "M0 0h120v120H0z"
})));

function SvgFigure4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure4);
export default __webpack_public_path__ + "static/media/figure-4.3306098e.svg";
export { ForwardRef as ReactComponent };